<div>
    <input
        type="text"
        [(ngModel)]="value"
        (ngModelChange)="inputChanged()"
        (focus)="inputChanged()"
        (blur)="disregardSuggestions()"
        (keydown)="onKeyDown($event)"
    />
</div>
<div *ngIf="suggestions && suggestions.length > 0" class="suggestions">
    <div *ngFor="let suggestion of suggestions; let i = index" class="suggestion" [class.selected]="selectedIndex === i" (click)="selectSuggestion(suggestion.value)">
        <div class="count">{{ suggestion.count | rf:'number' }}</div>
        {{ suggestion.value }}
    </div>
</div>